module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "mt-3"
  }, [_c('h1', {
    staticClass: "display-3"
  }, [_vm._v("Ошибка 404")]), _vm._v(" "), _c('h4', {
    staticClass: "pt-3"
  }, [_vm._v("Упс! Странца не найдена.")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("Возможно вы перешли по устаревшей ссылке.")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg btn-blcok btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.goHome($event)
      }
    }
  }, [_vm._v("Перейти на главную страницу")])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-c38fbc06", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// /home/alarmplan/staging/shared/frontend/~/vue-loader/lib/template-compiler?{"id":"data-v-c38fbc06"}!/home/alarmplan/staging/shared/frontend/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/404.vue
// module id = 1070
// module chunks = 1